<template>
    <div class="columns is-centered mt-6">
        <div class="column is-10 box is-block is-radiusless">
            <h5 class="is-primary is-uppercase has-text-weight-medium p-2">
                Listado de operadores
            </h5>
            <OperatorsTable :signalRSocket="signalRSocket" :skills="skills" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import OperatorsTable from "./OperatorsTable.vue";

export default {
    name: "online-operators-list",
    components: {
        OperatorsTable,
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
        skills: {
            type: Array,
            default: null,
        },
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
        isSupervisor() {
            let roles = this.oidcUser.role;
            return roles.indexOf("Supervisor") > -1;
        },
    },
    data() {
        return {};
    },
    async mounted() {
        if (!this.isSupervisor) {
            this.$router.push({
                name: "home",
            });
        }
    },
};
</script>
